
// import React from 'react';
// import { Box, Typography, Stack, CircularProgress, Alert } from '@mui/material';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'; // Import ArrowUpwardIcon

// // Define an interface for the props of CostSummaryCard
// interface CostSummaryCardProps {
//     title: string;
//     amount: string;

//     // Props for the "percentage" type tooltip
//     percentageChange?: string;
//     arrowRotation?: string;
//     tooltipText?: string;
//     changeType?: 'increase' | 'decrease'; // Added changeType for dynamic arrow color/direction

//     // Props for the "detail" type tooltip
//     tooltipType?: 'percentage' | 'detail'; // Existing tooltip types
//     detailIconSrc?: string;
//     detailText?: string;

//     // New props for the graph (line graph for percentage, bar graph for detail)
//     lineGraphData?: number[]; // Array of numbers for the line graph
//     lineGraphColor?: string; // Color of the line graph

//     barGraphData?: number[]; // Array of numbers for the bar graph
//     barGraphColor?: string; // Color of the individual bars in the bar graph

//     percentageOfTotal?: string; // New prop for "XX.X% of total" tooltip

//     // Additional prop for styling, if needed by parent (e.g., background image)
//     sx?: object;
// }

// // Reusable CostSummaryCard Component
// const CostSummaryCard = ({
//     title,
//     amount,
//     percentageChange,
//     arrowRotation,
//     tooltipText = 'vs last month',
//     tooltipType = 'percentage',
//     detailIconSrc,
//     detailText,
//     changeType, // Destructure changeType
//     lineGraphData, // Destructure lineGraphData
//     lineGraphColor = '#03A65A', // Default line graph color
//     barGraphData, // Destructure barGraphData
//     barGraphColor = '#03A65A', // Default bar graph color
//     percentageOfTotal, // Destructure percentageOfTotal
//     sx,
// }: CostSummaryCardProps) => {
//     // Determine arrow color based on changeType
//     const arrowColor = changeType === 'increase' ? '#027A48' : '#B42318';
//     const textColor = changeType === 'increase' ? '#03A65A' : '#B42318';

//     // Function to generate SVG path for a simple sparkline (line graph)
//     const generateSparklinePath = (data: number[], width: number, height: number) => {
//         if (!data || data.length < 2) return '';

//         const minVal = Math.min(...data);
//         const maxVal = Math.max(...data);

//         // Scale data to fit within SVG dimensions
//         const scaleX = (idx: number) => (idx / (data.length - 1)) * width;
//         const scaleY = (val: number) => {
//             if (minVal === maxVal) return height / 2; // Handle flat line
//             return height - ((val - minVal) / (maxVal - minVal)) * height;
//         };

//         const points = data.map((val, idx) => `${scaleX(idx)},${scaleY(val)}`).join(' ');
//         return `M${points}`;
//     };

//     // Function to render an SVG bar graph
//     const renderBarGraph = (data: number[], width: number, height: number, color: string) => {
//         // Limit to 4 bars
//         const displayData = data.slice(-4); // Take the last 4 data points

//         if (!displayData || displayData.length === 0) return null;

//         const maxVal = Math.max(...displayData);
//         // Adjusted barWidth and gap for thinner bars
//         const barWidth = (width / displayData.length) * 0.4; // Reduced to 40%
//         const gap = (width / displayData.length) * 0.6; // Increased gap to 60%

//         return (
//             <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
//                 {displayData.map((val, idx) => {
//                     const barHeight = maxVal === 0 ? 0 : (val / maxVal) * height;
//                     const x = idx * (barWidth + gap) + gap / 2;
//                     const y = height - barHeight;

//                     // Apply different opacity for bars based on position (e.g., all but the last)
//                     let fillColor = color;
//                     if (idx < displayData.length - 1) { // Apply lighter color to all but the last bar
//                         fillColor = `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, 0.4)`; // Adjust opacity
//                     }

//                     return (
//                         <rect
//                             key={idx}
//                             x={x}
//                             y={y}
//                             width={barWidth}
//                             height={barHeight}
//                             fill={fillColor}
//                             rx={2} // Rounded corners for bars
//                             ry={2}
//                         />
//                     );
//                 })}
//             </svg>
//         );
//     };

//     const graphWidth = 80;
//     const graphHeight = 20;

//     return (
//         <Box
//             sx={{
//                 mt: 2,
//                 // Responsive flex properties for the card itself
//                 minWidth: '220px', // Minimum width for the card
//                 flexGrow: 1, // Allow card to grow to fill available space
//                 flexShrink: 1, // Allow card to shrink if needed
//                 // Calculate maxWidth based on 5 cards and 16px gap to distribute evenly
//                 // This will make them fill the space when there's enough room for 5.
//                 // Adjust '5' if the number of cards changes.
//                 maxWidth: 'calc(100% / 5 - 16px)', // Max width to prevent excessive stretching

//                 height: 112, // Maintain overall height
//                 borderRadius: '16px',
//                 backgroundColor: '#F2F7FF',
//                 p: 2,
//                 backgroundImage: 'url(/textures/4th-card.svg)',
//                 backgroundRepeat: 'no-repeat',
//                 backgroundPosition: 'top right',
//                 backgroundSize: '300px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between', // Changed back to space-between
//                 alignItems: 'flex-start',
//                 position: 'relative', // Keep relative for background image positioning
//                 ...sx,
//             }}
//         >
//             {/* Row 1: Title */}
//             <Typography
//                 sx={{
//                     fontFamily: 'Inter',
//                     fontWeight: 500,
//                     fontSize: '14px',
//                     lineHeight: '21px',
//                     letterSpacing: '0.01px',
//                     color: '#666666',
//                 }}
//             >
//                 {title}
//             </Typography>

//             {/* Row 2: Amount and Graph/PercentageOfTotal container */}
//             <Box
//                 sx={{
//                     display: 'flex',
//                     alignItems: 'center', // Vertically center amount and graph/tooltip container
//                     justifyContent: 'space-between', // Push amount left, graph/tooltip container right
//                     width: '100%',
//                     mt: 0, // Changed from 0.5 to 0
//                     // Removed flexGrow: 1 from here
//                 }}
//             >
//                 {/* Amount */}
//                 <Typography
//                     sx={{
//                         fontFamily: 'Inter',
//                         fontWeight: 600,
//                         fontSize: '18px',
//                         lineHeight: '27px',
//                         color: '#333333',
//                     }}
//                 >
//                     {amount}
//                 </Typography>

//                 {/* Container for PercentageOfTotal Tooltip and Graph */}
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'flex-end', // Align items to the right within this column
//                         justifyContent: 'center', // Center vertically if needed
//                         mt: '4px', // Changed from 8px to 4px
//                     }}
//                 >
//                     {/* Conditional Tooltip Rendering for Percentage of Total (for Storage/Memory/CPU cards) - NOW ABOVE GRAPH */}
//                     {tooltipType === 'detail' && percentageOfTotal && (
//                         <Box
//                             sx={{
//                                 width: 'fit-content',
//                                 height: 20,
//                                 borderRadius: '50px',
//                                 backgroundColor: '#FFFFFF',
//                                 border: '1px solid #E6E6E6',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 gap: '4px',
//                                 pt: '2px',
//                                 pr: '8px',
//                                 pb: '2px',
//                                 pl: '4px',
//                                 mb: '4px', // Margin-bottom to separate from the graph below
//                             }}
//                         >
//                             <Typography
//                                 component="span"
//                                 sx={{
//                                     fontFamily: 'Inter',
//                                     fontWeight: 400,
//                                     fontSize: '12px',
//                                     lineHeight: '20px',
//                                     margin: 0,
//                                     letterSpacing: '0.01px',
//                                     color: '#666666',
//                                     transform: 'translateY(-1px)',
//                                     whiteSpace: 'nowrap',
//                                 }}
//                             >
//                                 {percentageOfTotal}
//                             </Typography>
//                         </Box>
//                     )}

//                     {/* Graph (Line or Bar) */}
//                     {lineGraphData && lineGraphData.length > 1 && (
//                         <Box sx={{ width: graphWidth, height: graphHeight }}>
//                             <svg width="100%" height="100%" viewBox={`0 0 ${graphWidth} ${graphHeight}`} preserveAspectRatio="none">
//                                 <polyline
//                                     fill="none"
//                                     stroke={lineGraphColor}
//                                     strokeWidth="1"
//                                     points={generateSparklinePath(lineGraphData, graphWidth, graphHeight).replace('M', '')}
//                                 />
//                             </svg>
//                         </Box>
//                     )}

//                     {barGraphData && barGraphData.length > 0 && (
//                         <Box sx={{ width: graphWidth, height: graphHeight }}>
//                             {renderBarGraph(barGraphData, graphWidth, graphHeight, barGraphColor)}
//                         </Box>
//                     )}
//                 </Box>
//             </Box>

//             {/* Row 3: Main Tooltips (percentageChange or detailText) - Now always at the bottom */}
//             {(tooltipType === 'percentage' && percentageChange) || (tooltipType === 'detail' && detailText) ? (
//                 <Stack
//                     direction="row"
//                     spacing={1}
//                     sx={{
//                         width: '100%',
//                         alignItems: 'center',
//                         justifyContent: 'flex-start', // Align these tooltips to the left
//                         // Removed mt: 'auto' from here
//                     }}
//                 >
//                     {/* Conditional Tooltip Rendering for Percentage Change (for Total/Forecasted cards) */}
//                     {tooltipType === 'percentage' && percentageChange && (
//                         <Box
//                             sx={{
//                                 width: 'fit-content',
//                                 height: 20,
//                                 borderRadius: '50px',
//                                 backgroundColor: '#FFFFFF',
//                                 border: '1px solid #E6E6E6',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'flex-start',
//                                 gap: '2px',
//                                 pt: '2px',
//                                 pr: '8px',
//                                 pb: '2px',
//                                 pl: '4px',
//                             }}
//                         >
//                             {changeType === 'increase' ? (
//                                 <ArrowUpwardIcon sx={{ width: '16px', height: '16px', color: arrowColor, transform: arrowRotation, ml: '1px' }} />
//                             ) : (
//                                 <ArrowDownwardIcon sx={{ width: '16px', height: '16px', color: arrowColor, transform: arrowRotation, ml: '1px' }} />
//                             )}
//                             <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', lineHeight: '16px', letterSpacing: '0.01px', color: textColor }}>
//                                 {percentageChange}
//                             </Typography>
//                             <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', lineHeight: '16px', color: '#666666', ml: '2px', mr: '2px' }}>
//                                 •
//                             </Typography>
//                             <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', lineHeight: '16px', letterSpacing: '0.01px', color: '#666666', whiteSpace: 'nowrap' }}>
//                                 {tooltipText}
//                             </Typography>
//                         </Box>
//                     )}

//                     {/* Conditional Tooltip Rendering for Detail Text (for Storage/Memory/CPU cards) */}
//                     {tooltipType === 'detail' && detailText && (
//                         <Box
//                             sx={{
//                                 width: 'fit-content',
//                                 height: 20,
//                                 borderRadius: '50px',
//                                 backgroundColor: '#FFFFFF',
//                                 border: '1px solid #E6E6E6',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 gap: '4px',
//                                 pt: '2px',
//                                 pr: '8px',
//                                 pb: '2px',
//                                 pl: '4px',
//                             }}
//                         >
//                             {detailIconSrc && (
//                                 <Box
//                                     component="img"
//                                     src={detailIconSrc}
//                                     alt="detail icon"
//                                     sx={{ width: '13.33px', height: '13.33px' }}
//                                 />
//                             )}
//                             <Typography
//                                 component="span"
//                                 sx={{
//                                     fontFamily: 'Inter',
//                                     fontWeight: 400,
//                                     fontSize: '12px',
//                                     lineHeight: '20px',
//                                     margin: 0,
//                                     letterSpacing: '0.01px',
//                                     color: '#666666',
//                                     transform: 'translateY(-1px)',
//                                     whiteSpace: 'nowrap',
//                                 }}
//                             >
//                                 {detailText}
//                             </Typography>
//                         </Box>
//                     )}
//                 </Stack>
//             ) : null}
//         </Box>
//     );
// };

// // Interface for KPIs from backend
// interface KubernetesKpiSet {
//     totalCost: number;
//     totalCostChangePercentage?: number;
//     forecastedCostChangePercentage?: number;
//     forecastedCost: number;
//     storageCost: number;
//     cpuCost: number;
//     memoryCost: number;
//     // Added for graph data - now separate for line vs bar
//     totalCostLineGraphData?: number[];
//     forecastedCostLineGraphData?: number[];

//     storageCostBarGraphData?: number[];
//     storageCostPercentageOfTotal?: number;

//     memoryCostBarGraphData?: number[];
//     memoryCostPercentageOfTotal?: number;

//     cpuCostBarGraphData?: number[];
//     cpuCostPercentageOfTotal?: number;
// }

// interface KubernetesSummaryCardsProps {
//     kpis: KubernetesKpiSet | null | undefined; // Updated type to include undefined
//     loading: boolean;
//     error?: Error | null;
//     comparisonText?: string;
// }

// // Helper to format numbers as currency
// const formatCurrency = (value: number | null | undefined) => {
//     if (value === null || value === undefined) return '$0.00';
//     return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// };

// // Helper to format percentages
// const formatPercentage = (value: number | null | undefined) => {
//     if (value === null || value === undefined) return '+0.00%';
//     const sign = value >= 0 ? '+' : ''; // Use >= 0 for positive or zero, otherwise it's negative
//     return `${sign}${value.toFixed(2)}%`;
// };

// const formatPercentageOfTotal = (value: number | null | undefined) => {
//     if (value === null || value === undefined) return '0.0%';
//     return `${value.toFixed(1)}% of total`;
// };

// // Main KubernetesSummaryCards Component
// const KubernetesSummaryCards: React.FC<KubernetesSummaryCardsProps> = ({ kpis, loading, error, comparisonText }) => {
//     if (loading) {
//         return (
//             <Stack direction="row" spacing={2} sx={{ width: '100%', mt: 2, alignItems: 'flex-start' }}>
//                 <Box sx={{ flex: 1, height: '112px', backgroundColor: '#f0f0f0', borderRadius: '16px' }} />
//                 <Box sx={{ flex: 1, height: '112px', backgroundColor: '#f0f0f0', borderRadius: '16px' }} />
//                 <Box sx={{ flex: 1, height: '112px', backgroundColor: '#f0f0f0', borderRadius: '16px' }} />
//                 <Box sx={{ flex: 1, height: '112px', backgroundColor: '#f0f0f0', borderRadius: '16px' }} />
//                 <Box sx={{ flex: 1, height: '112px', backgroundColor: '#f0f0f0', borderRadius: '16px' }} />
//             </Stack>
//         );
//     }

//     if (error) {
//         return (
//             <Alert severity="error" sx={{ mt: 2 }}>
//                 Error loading summary cards: {error.message}
//             </Alert>
//         );
//     }

//     // Default values if kpis is null or undefined
//     const defaultKpis: KubernetesKpiSet = {
//         totalCost: 0,
//         forecastedCost: 0,
//         storageCost: 0,
//         cpuCost: 0,
//         memoryCost: 0,
//         totalCostChangePercentage: 0,
//         forecastedCostChangePercentage: 0,
//         totalCostLineGraphData: [],
//         forecastedCostLineGraphData: [],
//         storageCostBarGraphData: [],
//         storageCostPercentageOfTotal: 0,
//         memoryCostBarGraphData: [],
//         memoryCostPercentageOfTotal: 0,
//         cpuCostBarGraphData: [],
//         cpuCostPercentageOfTotal: 0,
//     };
//     const currentKpis = kpis || defaultKpis;

//     // Example dummy graph data for demonstration.
//     // In a real application, this data would come from your backend.
//     const dummyTotalCostLineGraphData = [100, 110, 105, 120, 115, 130, 125];
//     const dummyForecastedCostLineGraphData = [90, 95, 100, 105, 110, 115, 120];

//     // Dummy bar graph data (example values, ensure at least 4 for demonstration)
//     const dummyStorageCostBarGraphData = [8, 10, 9, 12]; // Only 4 bars now
//     const dummyMemoryCostBarGraphData = [15, 18, 16, 19]; // Only 4 bars now
//     const dummyCpuCostBarGraphData = [25, 27, 26, 29]; // Only 4 bars now

//     return (
//         <Stack
//             direction="row"
//             flexWrap="wrap" // Allow cards to wrap to the next line
//             sx={{
//                 width: '100%',
//                 gap: '16px', // Consistent gap between cards
//                 mt: 0,
//                 overflowX: 'auto', // Keep horizontal scrolling for robustness, though wrapping should minimize it
//                 pb: 1, // Add some padding at the bottom for scrollbar
//                 justifyContent: 'flex-start', // Align cards to the start of the row
//             }}
//         >
//             {/* Total Kubernetes Cost Card - NO GRAPH */}
//             <CostSummaryCard
//                 title="Total Kubernetes Cost"
//                 amount={formatCurrency(currentKpis.totalCost)}
//                 percentageChange={formatPercentage(currentKpis.totalCostChangePercentage)}
//                 arrowRotation={currentKpis.totalCostChangePercentage && currentKpis.totalCostChangePercentage >= 0 ? 'rotate(-45deg)' : 'rotate(45deg)'}
//                 tooltipType="percentage"
//                 tooltipText={comparisonText}
//                 changeType={currentKpis.totalCostChangePercentage && currentKpis.totalCostChangePercentage >= 0 ? 'increase' : 'decrease'}
//                 sx={{ backgroundImage: 'url(/textures/1st-card.svg)' }}
//                 // No lineGraphData for these cards as per requirement
//             />

//             {/* Forecasted Cost Card - NO GRAPH */}
//             <CostSummaryCard
//                 title="Forecasted Cost"
//                 amount={formatCurrency(currentKpis.forecastedCost)}
//                 percentageChange={formatPercentage(currentKpis.forecastedCostChangePercentage)}
//                 arrowRotation={currentKpis.forecastedCostChangePercentage && currentKpis.forecastedCostChangePercentage >= 0 ? 'rotate(-45deg)' : 'rotate(45deg)'}
//                 tooltipType="percentage"
//                 tooltipText="vs last month"
//                 changeType={currentKpis.forecastedCostChangePercentage && currentKpis.forecastedCostChangePercentage >= 0 ? 'increase' : 'decrease'}
//                 sx={{ backgroundImage: 'url(/textures/2nd-card.svg)' }}
//                 // No lineGraphData for these cards as per requirement
//             />

//             {/* Storage Cost Card - BAR GRAPH and TWO TOOLTIPS at bottom */}
//             <CostSummaryCard
//                 title="Storage Cost"
//                 tooltipType="detail" // This will enable the detail text and percentage of total tooltips
//                 amount={formatCurrency(currentKpis.storageCost)}
//                 detailIconSrc={`${process.env.PUBLIC_URL}/icons/storage-icon.svg`}
//                 detailText="12 TB used"
//                 sx={{ backgroundImage: 'url(/textures/4th-card.svg)' }}
//                 barGraphData={currentKpis.storageCostBarGraphData || dummyStorageCostBarGraphData}
//                 barGraphColor={'#03A65A'}
//                 percentageOfTotal={formatPercentageOfTotal(currentKpis.storageCostPercentageOfTotal || 22.8)}
//             />

//             {/* Memory Cost Card - BAR GRAPH and TWO TOOLTIPS at bottom */}
//             <CostSummaryCard
//                 title="Memory Cost"
//                 tooltipType="detail"
//                 amount={formatCurrency(currentKpis.memoryCost)}
//                 detailIconSrc={`${process.env.PUBLIC_URL}/icons/network-cost-icon.svg`}
//                 detailText="1.2 TB transferred"
//                 sx={{ backgroundImage: 'url(/textures/4th-card.svg)' }}
//                 barGraphData={currentKpis.memoryCostBarGraphData || dummyMemoryCostBarGraphData}
//                 barGraphColor={'#03A65A'}
//                 percentageOfTotal={formatPercentageOfTotal(currentKpis.memoryCostPercentageOfTotal || 15.0)}
//             />

//             {/* CPU Cost Card - BAR GRAPH and TWO TOOLTIPS at bottom */}
//             <CostSummaryCard
//                 title="CPU Cost"
//                 tooltipType="detail"
//                 amount={formatCurrency(currentKpis.cpuCost)}
//                 detailIconSrc={`${process.env.PUBLIC_URL}/icons/storage-icon.svg`}
//                 detailText="8 GB used"
//                 sx={{ backgroundImage: 'url(/textures/4th-card.svg)' }}
//                 barGraphData={currentKpis.cpuCostBarGraphData || dummyCpuCostBarGraphData}
//                 barGraphColor={'#03A65A'}
//                 percentageOfTotal={formatPercentageOfTotal(currentKpis.cpuCostPercentageOfTotal || 30.5)}
//             />
//         </Stack>
//     );
// };

// export default KubernetesSummaryCards;

import React from 'react';
import { Box, Typography, Stack, CircularProgress, Alert } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

// Define an interface for the props of CostSummaryCard
interface CostSummaryCardProps {
    title: string;
    amount: string;
    percentageChange?: string;
    tooltipText?: string;
    changeType?: 'increase' | 'decrease';
    sx?: object;
}

// Reusable CostSummaryCard Component
const CostSummaryCard = ({
    title,
    amount,
    percentageChange,
    tooltipText = 'vs last month',
    changeType,
    sx,
}: CostSummaryCardProps) => {
    // Determine arrow and text color based on the change type
    const arrowColor = changeType === 'increase' ? ' #03A65A' : 'rgb(235, 58, 46)';
    const textColor = changeType === 'increase' ? ' #03A65A' : ' rgb(235, 58, 46)';

    return (
        <Box
            sx={{
                mt: 2,
                minWidth: '220px',
                flexGrow: 1,
                flexShrink: 1,
                maxWidth: 'calc(100% / 5 - 16px)',
                height: 112,
                borderRadius: '16px',
                backgroundColor: '#F2F7FF',
                p: 2,
                backgroundImage: 'url(/textures/4th-card.svg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top right',
                backgroundSize: '300px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                ...sx,
            }}
        >
            {/* Title */}
            <Typography
                sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#666666',
                }}
            >
                {title}
            </Typography>

            {/* Amount */}
            <Typography
                sx={{
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    fontSize: '18px',
                    color: '#333333',
                }}
            >
                {amount}
            </Typography>

            {/* Percentage Change Tooltip */}
            {percentageChange && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        width: '100%',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: 'fit-content',
                            height: 20,
                            borderRadius: '50px',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E6E6E6',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2px',
                            pt: '2px',
                            pr: '8px',
                            pb: '2px',
                            pl: '4px',
                        }}
                    >
                        {changeType === 'increase' ? (
                            <ArrowUpwardIcon sx={{ width: '16px', height: '16px', color: arrowColor,transform: 'rotate(-45deg)'}} />
                        ) : (
                            <ArrowDownwardIcon sx={{ width: '16px', height: '16px', color: arrowColor, transform: 'rotate(45deg)'}} />
                        )}
                        <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', color: textColor }}>
                            {percentageChange}
                        </Typography>
                        <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', color: '#666666', ml: '2px', mr: '2px' }}>
                            •
                        </Typography>
                        <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', color: '#666666', whiteSpace: 'nowrap' }}>
                            {tooltipText}
                        </Typography>
                    </Box>
                </Stack>
            )}
        </Box>
    );
};

// Interface for KPIs from backend
// MODIFIED: Added change percentages for Storage, Memory, and CPU
interface KubernetesKpiSet {
    totalCost: number;
    totalCostChangePercentage?: number;
    forecastedCost: number;
    forecastedCostChangePercentage?: number;
    storageCost: number;
    storageCostChangePercentage?: number; // New
    cpuCost: number;
    cpuCostChangePercentage?: number;     // New
    memoryCost: number;
    memoryCostChangePercentage?: number;  // New
}

interface KubernetesSummaryCardsProps {
    kpis: KubernetesKpiSet | null | undefined;
    loading: boolean;
    error?: Error | null;
    comparisonText?: string;
}

// Helper to format numbers as currency
const formatCurrency = (value: number | null | undefined) => {
    if (value === null || value === undefined) return '$0.00';
    return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Helper to format percentages
const formatPercentage = (value: number | null | undefined) => {
    if (value === null || value === undefined) return '+0.00%';
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(2)}%`;
};

// Main KubernetesSummaryCards Component
const KubernetesSummaryCards: React.FC<KubernetesSummaryCardsProps> = ({ kpis, loading, error, comparisonText }) => {
    if (loading) {
        return (
            <Stack direction="row" spacing={2} sx={{ width: '100%', mt: 2, alignItems: 'flex-start' }}>
                {[...Array(5)].map((_, index) => (
                    <Box key={index} sx={{ flex: 1, height: '112px', backgroundColor: '#f0f0f0', borderRadius: '16px' }} />
                ))}
            </Stack>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ mt: 2 }}>
                Error loading summary cards: {error.message}
            </Alert>
        );
    }

    // Default values if kpis is null or undefined
    const defaultKpis: KubernetesKpiSet = {
        totalCost: 0,
        forecastedCost: 0,
        storageCost: 0,
        cpuCost: 0,
        memoryCost: 0,
    };
    const currentKpis = kpis || defaultKpis;

    return (
        <Stack
            direction="row"
            flexWrap="wrap"
            sx={{
                width: '100%',
                gap: '16px',
                mt: 0,
                overflowX: 'auto',
                pb: 1,
                justifyContent: 'flex-start',
            }}
        >
            {/* Total Kubernetes Cost Card */}
            <CostSummaryCard
                title="Total Kubernetes Cost"
                amount={formatCurrency(currentKpis.totalCost)}
                percentageChange={formatPercentage(currentKpis.totalCostChangePercentage)}
                tooltipText={comparisonText}
                changeType={currentKpis.totalCostChangePercentage && currentKpis.totalCostChangePercentage >= 0 ? 'increase' : 'decrease'}
                sx={{ backgroundImage: 'url(/textures/1st-card.svg)' }}
            />

            {/* Forecasted Cost Card */}
            <CostSummaryCard
                title="Forecasted Cost"
                amount={formatCurrency(currentKpis.forecastedCost)}
                percentageChange={formatPercentage(currentKpis.forecastedCostChangePercentage)}
                tooltipText="vs last month"
                changeType={currentKpis.forecastedCostChangePercentage && currentKpis.forecastedCostChangePercentage >= 0 ? 'increase' : 'decrease'}
                sx={{ backgroundImage: 'url(/textures/2nd-card.svg)' }}
            />

            {/* MODIFIED: Storage Cost Card */}
            <CostSummaryCard
                title="Storage Cost"
                amount={formatCurrency(currentKpis.storageCost)}
                percentageChange={formatPercentage(currentKpis.storageCostChangePercentage)}
                tooltipText={comparisonText}
                changeType={currentKpis.storageCostChangePercentage && currentKpis.storageCostChangePercentage >= 0 ? 'increase' : 'decrease'}
                sx={{ backgroundImage: 'url(/textures/4th-card.svg)' }}
            />

            {/* MODIFIED: Memory Cost Card */}
            <CostSummaryCard
                title="Memory Cost"
                amount={formatCurrency(currentKpis.memoryCost)}
                percentageChange={formatPercentage(currentKpis.memoryCostChangePercentage)}
                tooltipText={comparisonText}
                changeType={currentKpis.memoryCostChangePercentage && currentKpis.memoryCostChangePercentage >= 0 ? 'increase' : 'decrease'}
                sx={{ backgroundImage: 'url(/textures/4th-card.svg)' }}
            />

            {/* MODIFIED: CPU Cost Card */}
            <CostSummaryCard
                title="CPU Cost"
                amount={formatCurrency(currentKpis.cpuCost)}
                percentageChange={formatPercentage(currentKpis.cpuCostChangePercentage)}
                tooltipText={comparisonText}
                changeType={currentKpis.cpuCostChangePercentage && currentKpis.cpuCostChangePercentage >= 0 ? 'increase' : 'decrease'}
                sx={{ backgroundImage: 'url(/textures/4th-card.svg)' }}
            />
        </Stack>
    );
};

export default KubernetesSummaryCards;